<template>
  <tr @click="isFolder ? $emit('open', item.id) : $emit('click')" class="inner cursor-pointer">
    <td>
        <div class="flex items-center w-auto">
            <div class="flex justify-items-center items-center w-13 h-13">
                <FolderComplete v-if="item.type === 'folder'" class="w-9 h-9 text-folderTopBlue"/>
                <img v-else-if="!includesVideo" :onerror="`this.onerror=null; this.src='${IMAGE_PLACEHOLDER}'`" class="w-full h-full rounded-lg object-cover"
                    :src="item.url"
                    alt="" />
                <video
                    ref="video"
                    v-else
                    class="w-full h-full object-cover rounded-lg"
                    @mouseleave="stop($event)"
                    @mouseenter="play($event)"
                    muted
                    loop
                >
                    <source :src="item.url" :type="item.mime_type && item.mime_type !== 'video/quicktime' ? item.mime_type : 'video/mp4'">
                    Your browser does not support the video tag.
                </video>
            </div>
                <div class="ml-3 truncate w-28">
                    <h2 class="text-yank whitespace-no-wrap text-base truncate">
                        {{item.name}}
                    </h2>
                </div>
            </div>
    </td>
    <td>
        <p class="w-52 xl:w-64 truncate">{{item.description ? item.description : '-'}}</p>
    </td>
    <td>
        <p>
            {{item.mime_type ? item.mime_type : '-'}}
        </p>
    </td>
    <td>
        <p>
            {{item.size ? item.size : '-'}}
        </p>
    </td>
    <td>
        <div class="flex items-center justify-end space-x-2">
            <button v-if="!isFolder" @click.stop="$emit('openMoveModal', item)" class="border-2 p-3 border-gray rounded-lg cursor-pointer text-payneFire">
                <MoveFolderIcon class="w-3 h-3"/>
            </button>
            <button @click.stop="isFolder ? $emit('openRenameModal', item) : $emit('openDetails', item)" class="border-2 p-3 border-gray rounded-lg cursor-pointer text-payneFire">
                <EditIcon class="w-3 h-3"/>
            </button>     
            <button  @click.stop="isFolder ? $emit('openDeleteModal', item) : $emit('deleteItem', item)" class="border-2 border-gray p-2 rounded-lg cursor-pointer text-payneFire">
                <TrashIcon/>
            </button>
        </div>
    </td>
</tr>
</template>

<script>
import FolderComplete from '@/components/svg/FolderComplete'
import TrashIcon from '@/components/svg/TrashIcon'

import { IMAGE_PLACEHOLDER } from '@/utils/constants';

import MoveFolderIcon from '../../../svg/MoveFolderIcon';
import EditIcon from '../../../svg/EditIcon';

export default {
    name:"Row",

    components: {
    FolderComplete,
    TrashIcon,
    EditIcon,
    MoveFolderIcon
},

    props: {
        item: {
            type: Object,
            required: true,
        },
        isFolder: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            IMAGE_PLACEHOLDER  
        }
    },

    computed: {
        includesVideo() {
            return this.item && this.item.mime_type.includes('video');
        },
    },

    methods: {
        play(event) {
            event.target.play();
        },
        stop(event) {
            event.target.pause();
        },
    }
}
</script>

<style scoped>
 td{
     @apply px-5 py-5 border-b border-gray-200 bg-white text-sm
 }
 p{
     @apply text-payne
 }
</style>